import { QuestionRepository } from "../../../../data/repository/question/QuestionRepository";
import {
  GetRandomQuestionRequestModel,
  Question,
} from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetRandomQuestionUseCase {
  invoke: (
    getRandomQuestionRequestModel: GetRandomQuestionRequestModel
  ) => Promise<ResponseState<Question>>;
}

export class GetRandomQuestionUseCaseImpl implements GetRandomQuestionUseCase {
  private questionRepository: QuestionRepository;

  constructor(questionRepository: QuestionRepository) {
    this.questionRepository = questionRepository;
  }

  async invoke(
    getRandomQuestionRequestModel: GetRandomQuestionRequestModel
  ): Promise<ResponseState<Question>> {
    try {
      let response = await this.questionRepository.getRandomQuestion(
        getRandomQuestionRequestModel
      );
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
